import { apiRequest } from './api'
import type { ChatMessage } from '../types'
export interface ExportSnapshot { title:string;created:string;exported_at:string;saved_snapshot:boolean;generation_active:boolean;messages:ChatMessage[] }
export function getExport(id:string) { return apiRequest<ExportSnapshot>(`/v1/conversations/${id}/export`) }
export function toMarkdown(snapshot:ExportSnapshot):string {
  const blocks=[`# ${snapshot.title.replace(/[\r\n]/g,' ')}`,`导出时间：${snapshot.exported_at}`, '此文件仅包含导出时已保存的记录。']
  if(snapshot.generation_active) blocks.push('当前仍有回答生成中，未完成部分不包含在本次导出中。')
  for(const m of snapshot.messages) {
    blocks.push(`## 问题 ${m.turn} · ${m.role==='user'?'提问':m.public_label?`回答 ${m.public_label}（第 ${m.ab_round||1} 轮）`:'回答'}`)
    if(m.status==='failed'||m.status==='streaming') blocks.push('> 此回答未完成，不作为有效评价回答。')
    blocks.push(m.content||'（未保存正文）')
    if(m.citations?.length) blocks.push('教材引用：\n'+m.citations.map(c=>`- [${c.source_id}] ${c.book} · ${c.chapter}${c.section?' · '+c.section:''}${c.page_start?` · 第 ${c.page_start}–${c.page_end} 页`:''}`).join('\n'))
    if(m.public_label && snapshot.messages.filter(x=>x.turn===m.turn && x.ab_round===m.ab_round && x.public_label && x.status==='complete').length<2) blocks.push('> 本轮双回答未完整保存。')
  }
  return blocks.join('\n\n')+'\n'
}
export async function downloadMarkdown(id:string) {
  const snapshot=await getExport(id)
  const blob=new Blob([toMarkdown(snapshot)],{type:'text/markdown;charset=utf-8'})
  const url=URL.createObjectURL(blob)
  const link=document.createElement('a')
  const name=snapshot.title.replace(/[<>:"/\\|?*\u0000-\u001f]/g,'_').trim().slice(0,80)||'学习对话'
  link.href=url;link.download=`${name}-${snapshot.exported_at.slice(0,10)}.md`
  link.click();setTimeout(()=>URL.revokeObjectURL(url),1000)
}
